import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
// import MainLayout from "../layout/MainLayout"; import {
// TimeDatePickerCalendar,AllBadges,AllButtons,AllDifferentInputType,AllDropDown
// , AllInputs,AllProgressBars,AllTypographys,AllUploadType,AllToasts } from
// "../pages";
import {
    MainAdminLogs,
   
    Login,
   
      MainAdminUsers,
      MainAdminUniversities,
      MainAdminFields,
      MainAdminTeachers,
      MainAdminColleges,
      MainAdminCollegeFields,
      MainAdminCollegeField,
      MainAdminCollegeFieldTeachers,
      UserEmailes,
      Jobs,
      Chat,
      MainAdminPublishedNewses,
      MainAdminScheduledArticles,
      MainAdminRejectedNewses,
      MainAdminNewsPendingConfirmation,
      MainAdminNewsCategory,
      MainAdminNewsCategoryAdd,
      MainAdminNewsCategoryEdit,
      MainAdminTagsCategory,
      MainAdminTagsCategoryAdd,
      MainAdminTagsCategoryEdit,
      MainAdminUploadNews,
      MainAdminEditNews,
      MainAdminUploadNewsRelease,
      MainAdminEditNewsRelease,
      MainAdminUploadNewsConfirmation,
      MainAdminPlans,
      MainAdminPlanOptions,
      MainAdminJobs,
      MainAdminJobApplies,
      PublicJobs,
  Archive,
    ArchiveAllNews,
    Tag, AboutUs,
    SingleNews,ContactUs

} from "../components";
import HomePage from "../pages/Home/HomePage";
import NewUILayout from "../layout/NewUILayout";

import LayoutMainAdmin from "../layout/LayoutMainAdmin";
import LayoutUser from "../layout/LayoutUser";
import SignUp from "../pages/SignUp";
import AutomationDashboard from "../pages/User/AutomationDashboard";
import CampaignCreatePage from "../pages/User/CampaignCreatePage";
import CampaignReviewPage from "../pages/User/CampaignReviewPage";
import AdminOverview from "../pages/MainAdminPage/AdminOverview";
import Checkout from "../pages/Home/Checkout";
import LegalPage from "../pages/Home/LegalPage";

export const router = createBrowserRouter([


    // {
    //     path: "/",
    //     element: <NewUILayout />,
    //     errorElement: (
    //         <h3 className="text-center">Nothing !</h3>
    //     ),
    //     children: [
    //         {
    //             path: '/',
    //             element: <HomePage />
    //         }
    //         , {
    //             path: '/news/:cat/:id',  
    //             element: <SingleNews />
    //         }
        
    //         ,{
    //             path: '/contact-us',
    //             element: <ContactUs />
    //         }, {
    //             path: '/archive/:id',
    //             element: <Archive />
    //         },
    //         {
    //             path: '/archiveAllNews/:id',
    //             element: <ArchiveAllNews />
    //         },
    //         {
    //             path: '/Tag/:id',
    //             element: <Tag />
    //         },
          
    //         {
    //             path: '/about-us',
    //             element: <AboutUs />
    //         }
    //     ]
    // },
     {
        path: "/mainAdmin",
        element: <LayoutMainAdmin />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        ),
        children: [
            {
                index: true,
                element: <AdminOverview />
            },
            {
                path: '/mainAdmin/logs',
                element: <MainAdminLogs />
            },
            {
                path: '/mainAdmin/users',
                element: <MainAdminUsers />
            },
            {
                path: '/mainAdmin/teachers',
                element: <MainAdminTeachers/>
            },
            {
                path: '/mainAdmin/fields',
                element: <MainAdminFields/>
            },
            {
                path: '/mainAdmin/universities',
                element: <MainAdminUniversities />
            },
            {
                path: '/mainAdmin/colleges',
                element: <MainAdminColleges />
            },
            {
                path: '/mainAdmin/collegeFields',
                element: <MainAdminCollegeFields />
            },
            {
                path: '/mainAdmin/collegeField/:collegeFieldId?',
                element: <MainAdminCollegeField />
            },
            {
                path: '/mainAdmin/collegeFieldTeachears',
                element: <MainAdminCollegeFieldTeachers />
            }
            ,
            {
                path: '/mainAdmin/PublishedNewses',
                element: <MainAdminPublishedNewses />
            },
            {
                path: '/mainAdmin/ScheduledNews',
                element: <MainAdminScheduledArticles />
            },
            {
                path: '/mainAdmin/rejectedNewses',
                element: <MainAdminRejectedNewses />
            }, 
            {
                path: '/mainAdmin/newsPendingConfirmation',
                element: <MainAdminNewsPendingConfirmation />
            },
            {
                path: '/mainAdmin/plans',
                element: <MainAdminPlans/>
            },
            {
                path: '/mainAdmin/planoptions',
                element: <MainAdminPlanOptions/>
            },
            {
                path: '/mainAdmin/jobs',
                element: <MainAdminJobs />
            },
            {
                path: '/mainAdmin/jobApplies',
                element: <MainAdminJobApplies />
            },
             {
                path: '/mainAdmin/newsCategory',
                element: <MainAdminNewsCategory />,
                children: [
                    {
                        path: '/mainAdmin/newsCategory/add',
                        element: <MainAdminNewsCategoryAdd />
                    }, {
                        path: '/mainAdmin/newsCategory/edit',
                        element: <MainAdminNewsCategoryEdit />
                    }
                ]
            },
            {
                path: '/mainAdmin/tagsCategory',
                element: <MainAdminTagsCategory />,
                children: [
                    {
                        path: '/mainAdmin/tagsCategory/add',
                        element: <MainAdminTagsCategoryAdd />
                    }, {
                        path: '/mainAdmin/tagsCategory/edit',
                        element: <MainAdminTagsCategoryEdit />
                    }
                ]
            }, {
                path: '/mainAdmin/uploadNews',
                element: <MainAdminUploadNews />,
                children: [
                    {
                        path: '/mainAdmin/uploadNews/release',
                        element: <MainAdminUploadNewsRelease />
                    }, {
                        path: '/mainAdmin/uploadNews/confirmation',
                        element: <MainAdminUploadNewsConfirmation />
                    }
                ]
            }, {
                path: '/mainAdmin/editNews',
                element: <MainAdminEditNews />,
                children: [
                    {
                        path: '/mainAdmin/editNews/release',
                        element: <MainAdminEditNewsRelease />
                    }
                ]
            },
    
         

        ]
    },

    {
        path: "/user",
        element: <LayoutUser />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        ),
        children: [
            {
                index: true,
                element: <Navigate to="/user/dashboard" replace />
            },
            {
                path: '/user/dashboard',
                element: <AutomationDashboard />
            },
            {
                path: '/user/campaign/new/study',
                element: <CampaignCreatePage goalType="Study" />
            },
            {
                path: '/user/campaign/new/job',
                element: <CampaignCreatePage goalType="Job" />
            },
            {
                path: '/user/campaign/:id/review',
                element: <CampaignReviewPage />
            },
            {
                path: '/user/chooseTemplate',
                element: <Navigate to="/user/dashboard" replace />
            },
            {
                path: '/user/newRequestApply',
                element: <Navigate to="/user/dashboard" replace />
            },
{
                path: '/user/userEmailes',
                element: <UserEmailes />
            },
            {
                path: '/user/jobs',
                element: <Jobs />
            },
           
          

        ]
    },
    {
        path: "/SignIn",
        element: <Login />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    }
    ,{
        path: "/SignUp",
        element: <SignUp />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    }
    , {
        path: "/chat",
        element: <Chat />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        )
    },
      
      {
        path: "/",
        element: <NewUILayout />,
        errorElement: (
            <h3 className="text-center">Nothing !</h3>
        ),
        children: [
            {
                path: '/',
                element: <HomePage />
            }
            , {
                path: '/blog-details/:id',  
                element: <SingleNews />
            }
        
            ,{
                path: '/contact-us',
                element: <ContactUs />
            }, {
                path: '/archive/:id',
                element: <Archive />
            },
            {
                path: '/archiveAllNews/:id',
                element: <ArchiveAllNews />
            },
            {
                path: '/Tag/:id',
                element: <Tag />
            },
          
            {
                path: '/about-us',
                element: <AboutUs />
            },
            {
                path: '/jobs',
                element: <PublicJobs />
            },
            {
                path: '/checkout',
                element: <Checkout />
            },
            {
                path: '/privacy-policy',
                element: <LegalPage type="privacy" />
            },
            {
                path: '/terms-of-service',
                element: <LegalPage type="terms" />
            }
        ]
    },
])
